import { patchHistoryReplaceStateForBfcache } from '~/utils/router/patchHistoryReplaceStateForBfcache';

// Install before vue-router createWebHistory registers its pagehide listener.
patchHistoryReplaceStateForBfcache();

export default defineNuxtPlugin({
  name: 'bfcache-scroll-state',
  enforce: 'pre'
});
